import clsx from 'clsx';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useParams } from 'react-router-dom';

import { RootState } from '@/src/reducers/types';
import { useTeamMembers } from '@/src/components/project/Dashboard/components/TeamMembers/api/getTeamMembers';
import AvatarGroup from '@/src/components/project/Dashboard/components/TeamMembers/AvatarGroup';

const ProjectMenu = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const project = useSelector((store: RootState) => store.project);
  const selected = project.Selected;

  const { lookerReports, showLookerReport } = useSelector(
    (store: RootState) => store.project.Selected
  );

  const menus = useMemo(() => {
    const baseMenus = [
      { id: 'dashboard', label: 'Dashboard', link: '' },
      { id: 'reports', label: 'Reports', link: '/reports' },
      { id: 'inbox', label: 'Inbox', link: '/inbox?view=All' },
      //{ id: 'inbox2', label: 'Inbox2', link: '/inbox2' },
      { id: 'processes', label: 'Processes', link: '/processes' },
      { id: 'files', label: 'Library', link: '/files' },
      // { id: 'calendar', label: 'Calendar', link: '/calendar' },
      { id: 'settings', label: 'Settings', link: '/settings' },
    ];

    const shouldShowReportsMenu = (() => {
      if (showLookerReport) {
        return lookerReports.length > 0;
      } else {
        return false;
      }
    })();

    const filteredMenus = baseMenus.filter((m) =>
      m.id !== 'reports' ? true : shouldShowReportsMenu
    );

    return filteredMenus;
  }, [selected, showLookerReport, lookerReports]);

  const teamMembersQuery = useTeamMembers({
    projectId,
  });

  return (
    <div
      className={clsx(
        'accountMenu--wrapper accountProjectMenu ',
        'hidden-sm hidden-xs',
        'tw-pb-[2px]',
        'tw-bg-white',
        'tw-border-b-[1px] tw-border-solid tw-border-cfo-grey-500'
      )}
    >
      <div className={clsx('project-menu-container', 'tw-flex tw-items-center')}>
        {menus.map((m) => {
          return (
            <div
              className={`accountMenuItem ${m.id === 'processes' ? 'allTasks' : ''}`}
              key={`project_menu_${m.id}`}
            >
              <NavLink
                exact={
                  m.id === 'workstreams' || m.id === 'settings' || m.id === 'processes'
                    ? false
                    : true
                }
                to={`/projects/${projectId + m.link}`}
              >
                {m.id === 'info' ? (
                  <div>
                    <span>
                      <img
                        src={`/api/file/project_pictures/${selected.picture}`}
                        alt="Project"
                        className="img-responsive"
                      />
                    </span>
                  </div>
                ) : (
                  m.label
                )}
              </NavLink>
            </div>
          );
        })}
      </div>
      <div className={clsx('tw-pr-[20px]')}>
        <AvatarGroup users={teamMembersQuery.data?.users} />
      </div>
    </div>
  );
};

export default ProjectMenu;
